import { z } from "zod";

export const addressSchema = z.object({
  street_address: z.string().nullable().optional(),
  city: z.string().nullable().optional(),
  region: z.string().nullable().optional(),
  postal_code: z.string().nullable().optional(),
  country: z.string().nullable().optional(),
});

export type Address = z.infer<typeof addressSchema>;
